// Six ways comparison page (sections/six-ways-page.liquid). Paid traffic from one ad lands here and
// every button goes to the quiz. This file runs the page (FAQ, sticky bar, clips, carousel), carries
// the visit's ad parameters onto every quiz link, and announces six-ways:<state> events on document.
// assets/analytics-posthog-funnel.js names and sends them; window.__sixWaysQueue keeps the ones that
// fire before that file loads.
(function () {
  var root = document.querySelector('[data-six-ways]');
  if (!root || root.__sixWays) return;
  root.__sixWays = true;

  var queue = (window.__sixWaysQueue = window.__sixWaysQueue || []);
  function announce(state, detail) {
    queue.push({ state: state, detail: detail || {} });
    try {
      document.dispatchEvent(new CustomEvent('six-ways:' + state, { detail: detail || {} }));
    } catch (e) {}
  }

  // Customer video stills (data-poster) load when their row comes within 600px of the screen,
  // as on the Connoisseur offer page. The clips themselves stay preload="none" until tapped.
  (function () {
    function stills(row) {
      row.querySelectorAll('video[data-poster]').forEach(function (v) {
        v.setAttribute('poster', v.getAttribute('data-poster'));
        v.removeAttribute('data-poster');
      });
    }
    var rows = root.querySelectorAll('.wlb-ugc');
    if (!('IntersectionObserver' in window)) { rows.forEach(stills); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { stills(e.target); io.unobserve(e.target); } });
    }, { rootMargin: '600px 0px' });
    rows.forEach(function (r) { io.observe(r); });
  })();

  // Ad parameters: read from this URL, else from the copy kept for this tab (a reload or a back
  // from the quiz can drop the query string), then added to every quiz link that lacks them.
  var KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id', 'fbclid', 'gclid', 'ttclid'];
  var STORE = 'wl_six_ways_params';
  var params = {};
  try {
    var q = new URLSearchParams(window.location.search || '');
    KEYS.forEach(function (k) { var v = q.get(k); if (v) params[k] = v; });
    if (Object.keys(params).length) sessionStorage.setItem(STORE, JSON.stringify(params));
    else params = JSON.parse(sessionStorage.getItem(STORE) || '{}') || {};
  } catch (e) {}
  var quizLinks = root.querySelectorAll('a[href*="/pages/quiz-questions"]');
  quizLinks.forEach(function (a) {
    try {
      var url = new URL(a.getAttribute('href'), window.location.origin);
      Object.keys(params).forEach(function (k) { if (!url.searchParams.has(k)) url.searchParams.set(k, params[k]); });
      a.setAttribute('href', url.pathname + url.search + url.hash);
    } catch (e) {}
  });

  announce('viewed', { utm_term: params.utm_term || null, utm_campaign: params.utm_campaign || null });

  // The order records which page the buyer saw: one cart attribute, written once per tab
  // session on the first quiz click. Cart attributes reach the order and Recharge copies them
  // onto renewals; /cart/clear.js on the offer page empties lines, not attributes.
  var TAGGED = 'six_ways_cart_tagged';
  function tagCart() {
    try {
      if (sessionStorage.getItem(TAGGED)) return;
    } catch (e) { return; }
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        keepalive: true,
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { _landingPage: 'six-ways' } })
      }).then(function (r) {
        // Mark only a saved attribute, so a failed request retries on the next click.
        if (r.ok) { try { sessionStorage.setItem(TAGGED, '1'); } catch (e) {} }
      }).catch(function () {});
    } catch (e) {}
  }

  quizLinks.forEach(function (a, i) {
    a.addEventListener('click', function () {
      tagCart();
      var where = a.closest('[data-six-ways-cta]');
      announce('quiz_clicked', {
        cta: where ? where.getAttribute('data-six-ways-cta') : (a.classList.contains('ql-cta-sticky__btn') ? 'sticky' : 'button_' + (i + 1)),
        utm_term: params.utm_term || null
      });
    });
  });

  // FAQ: one toggle per question; the first open of each question is announced.
  root.querySelectorAll('.quiz-faq__item').forEach(function (item, i) {
    var b = item.querySelector('.quiz-faq__button');
    var t = item.querySelector('.quiz-faq__toggle');
    var told = false;
    if (!b) return;
    b.addEventListener('click', function () {
      var open = item.classList.toggle('is-open');
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (t) t.textContent = open ? '-' : '+';
      if (open && !told) {
        told = true;
        announce('faq_opened', { question: i + 1 });
      }
    });
  });

  // Phone sticky bar: shown only when no in-page quiz button is on screen.
  var sticky = root.querySelector('#sticky');
  var btns = root.querySelectorAll('.quiz-btn');
  if (sticky && btns.length && 'IntersectionObserver' in window) {
    var vis = new Set();
    var sio = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) vis.add(e.target); else vis.delete(e.target); });
      sticky.classList.toggle('ql-cta-sticky--hidden', vis.size > 0);
    });
    btns.forEach(function (b) { sio.observe(b); });
  }

  // Member clips: the still shows until play is tapped; one plays at a time, with sound.
  var vids = root.querySelectorAll('.wlb-ugc video');
  root.querySelectorAll('.wlb-ugc .mb-offer-ugc__play').forEach(function (btn, i) {
    btn.addEventListener('click', function () {
      var v = btn.parentNode.querySelector('video');
      if (!v) return;
      btn.hidden = true;
      v.controls = true;
      try { v.focus(); } catch (e) {}
      v.muted = false;
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
      announce('clip_played', { clip: i + 1 });
    });
  });
  vids.forEach(function (v) {
    v.addEventListener('play', function () {
      vids.forEach(function (o) { if (o !== v && !o.paused) o.pause(); });
    });
  });

  // Member box carousel: arrows scroll one card, dots follow the scroll position.
  root.querySelectorAll('[data-carousel]').forEach(function (p) {
    var c = p.querySelector('.carousel');
    if (!c) return;
    var items = c.querySelectorAll('.carousel__item');
    var dots = p.querySelectorAll('.carousel__dot');
    if (!items.length) return;
    var w = function () { return items[0].getBoundingClientRect().width + 10; };
    var prev = p.querySelector('.carousel__btn--prev');
    var next = p.querySelector('.carousel__btn--next');
    if (prev) prev.addEventListener('click', function () { c.scrollBy({ left: -w(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { c.scrollBy({ left: w(), behavior: 'smooth' }); });
    c.addEventListener('scroll', function () {
      var i = Math.min(Math.round(c.scrollLeft / w()), dots.length - 1);
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }, { passive: true });
  });
})();
